import { get } from '../../utils/parseVast';
import { MediaType, event, AD_BEFORE_UNLOAD_DELAY, AD_BEFORE_COMPLETE_DELAY, Multiads, AdvIDPrefix, APICallMethod } from '../../utils/const';
import { createAdSlot, createVideoSlot, clearAllTimers, getRandomString, logOnServerDebugInfo } from '../../utils/utils';
// import { timeouts } from '../../utils/options';
import { API } from '../../utils/api';

import getVPAIDAd from './viaVPAID';
import VPAID from './VPAID';

const BETWEEN_VPAID_DOMAIN = 'cache.betweendigital.com'; // uncommon module behavior for VPAIDs on this domain
const VIRALIZE_VPAID_DOMAIN = 'static.viralize.tv/viralize_vpaid'; // user interaction must be handled for viralize vpaid
const SECURE_VPAID_DOMAIN = 'https://static.skwstat.ru/v20/vpaid.js';
const KINOSTREAM_VPAID_DOMAIN = 'kinostream.media';// 'kinostream.media/vpaid/vp.embed.1.0.js';

async function VPAIDModule({ vastUrl, emitter, playerNode, vastParser, trackers, baseTrackers, params, config, socket, isChildVast = false, timeouts, logger, uiManager, parentAdvInfo, parentVastPrice = 0, queueManager, impressionDetector }) {
  let unit = null;
  let advID = null;
  let vpaidMediaUrl = '';

  // const mediaFilesContainsType = (mediaFiles, type) => {
  //   return Boolean(mediaFiles.find((mediaFile) => mediaFile.mimetype === type));
  // }

  const parseTrackers = (ad) => {
    let vastTrackers = {};
    const makeUniqueTrackerList = (trackers) => {
      const list = {};

      Object.entries(trackers).forEach(([tracker, value]) => {
        list[tracker] = [...value];
      });

      return list;
    }

    const pushTrackersToList = (trackers, eventName) => {
      trackers.forEach((trackingNode) => {
        const event = eventName || trackingNode.getAttribute('event');
        const url = trackingNode.textContent.trim();

        if (vastTrackers[event]) {
          vastTrackers[event].push(url);
        } else {
          vastTrackers[event] = [url];
        }
      });
    }

    vastTrackers = makeUniqueTrackerList(trackers);

    const trackingNodes = [...get(ad, 'Tracking')];
    if (trackingNodes.length) pushTrackersToList(trackingNodes);

    const impressionTrackingNodes = [...get(ad, 'Impression')];
    if (impressionTrackingNodes.length) pushTrackersToList(impressionTrackingNodes, 'impression');

    const errorTrackingNodes = [...get(ad, 'Error')];
    if (errorTrackingNodes.length) pushTrackersToList(errorTrackingNodes, 'error');

    const clickTrackingNodes = [...get(ad, 'ClickTracking')];
    if (clickTrackingNodes.length) pushTrackersToList(clickTrackingNodes, 'click');

    return vastTrackers;
  }

  const parseAd = async (ad) => {
    const currentAdTrackers = parseTrackers(ad);
    const clickThruNode = get(ad, 'ClickThrough')[0];
    const pricingNodes = [...get(ad, 'Pricing')];

    const advInfo = parentAdvInfo || { title: 'Реклама', url: '#' };
    let vastPrice = parentVastPrice || 0;
    // const advInfo = { title: '', url: '' };

    if (pricingNodes.length && !isChildVast) {
      const USDPricingNodes = pricingNodes.filter(node => node.getAttribute('currency') === 'USD' && (node.parentNode.tagName === 'Wrapper' || node.parentNode.tagName === 'InLine'));
      if (USDPricingNodes[0]) vastPrice = parseFloat(USDPricingNodes[0].textContent);
    }

    const extensionNodes = [...get(ad, 'Extension')];

    if (extensionNodes.length) {
      const viadsExtensionNodes = extensionNodes.filter((node) => node.getAttribute('type') === 'ads-direct');
      const advInfoExtensionNodes = extensionNodes.filter((node) => node.getAttribute('type') === 'nroa_inform'); // nroa

      if (advInfoExtensionNodes.length) {
        advInfoExtensionNodes.forEach((node) => {
          advInfo.title = get(node, 'Title')[0].textContent;
          advInfo.url = get(node, 'Url')[0].textContent;
        });
      }

      if (viadsExtensionNodes.length) {
        viadsExtensionNodes.forEach((node) => {
          const priorityNode = get(node, 'priority')[0];

          if (priorityNode) {
            params.priority = +priorityNode.textContent;
          }
        });
      }
    }

    const mediaFiles = [...get(ad, 'MediaFile')].map((mediaFileNode) => {
      const mediaType = mediaFileNode.getAttribute('type');
      const mediaSource = mediaFileNode.textContent;

      return ({
        mimetype: mediaType,
        url: mediaSource,
      });
    }).filter((mediaFile) => {
      if (!config.bl) return true;
      
      return !config.bl.some(url => mediaFile.url.includes(url));
    });

    if (mediaFiles.length) {
      emitter.emit(event.Player.PlayerLog, params.tid, 'parsing mediaFiles');
      const videoSlot = params.vpaid === 1 ? undefined : createVideoSlot();
      // const slot = createAdSlot(params.vpaid === 1 ? [] : [videoSlot]);
      let originalSlot = null;

      // slot.setAttribute('platform', 'vpaid');
      // slot.setAttribute('tid', params.tid);

      // playerNode.appendChild(slot);

      // emitter.emit(event.Player.AdPreloaded, new VPAID({ emitter, playerNode, playerConfig: config, socket, params, ad, baseTrackers, trackers: currentAdTrackers, logger, clickThruNode, media: mediaFiles, uiManager, timeouts, advInfo: { ...advInfo }, vastPrice, queueManager, impressionDetector }));
      new VPAID({ emitter, playerNode, playerConfig: config, socket, params, ad, baseTrackers, trackers: currentAdTrackers, logger, clickThruNode, media: mediaFiles, uiManager, timeouts, advInfo: { ...advInfo }, vastPrice, queueManager, impressionDetector });
      return;
      if (mediaFilesContainsType(mediaFiles, MediaType.JS)) {
        emitter.emit(event.Player.PlayerLog, params.tid, 'parsing VPAID ad');
        const vpaidMedia = mediaFiles[0];
        const adParametersNode = get(ad, 'AdParameters')[0];
        const adParameters = adParametersNode?.textContent || "{}";

        advID = AdvIDPrefix.VPAID + getRandomString();

        let secureMode = params.vpaid === 1;
        if (vpaidMedia.url.includes(SECURE_VPAID_DOMAIN)) {
          secureMode = true;
        }

        const vpaidFrame = document.createElement('iframe');
        vpaidFrame.setAttribute('allowfullscreen', '');
        vpaidFrame.setAttribute('mozallowfullscreen', '');
        vpaidFrame.setAttribute('webkitallowfullscreen', '');
        vpaidFrame.setAttribute('frameborder', '0');
        vpaidFrame.setAttribute('allow', 'autoplay');
        vpaidFrame.setAttribute('sandbox', 'allow-forms allow-same-origin allow-pointer-lock allow-scripts allow-popups allow-top-navigation');
        vpaidFrame.style.cssText = secureMode ? 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 9999; overflow: hidden;' : 'display: none;';

        vpaidFrame.onload = () => {
          vpaidFrame.contentWindow.onVPAIDLoad = () => {
            const { getVPAIDAd } = vpaidFrame.contentWindow;

            if (getVPAIDAd) {
              emitter.emit(event.Player.PlayerLog, params.tid, 'VPAID script correctly loaded');

              const vpaidClickThruURL = clickThruNode ? clickThruNode.textContent : '';

              const specialBehavior = vpaidMedia.url.includes(BETWEEN_VPAID_DOMAIN) || vpaidMedia.url.includes(KINOSTREAM_VPAID_DOMAIN);

              unit = {
                slot,
                advID,
                trackers: currentAdTrackers,
                baseTrackers,
                params,
                paused: false,
                userInteracted: false,
                isImpressionEmitted: false,
                isViralize: vpaidMedia.url.includes(VIRALIZE_VPAID_DOMAIN),
                vpaidClickThruURL,
              };

              // originalSlot = secureMode ? slot : null;
              vpaidFrame.contentDocument.body.style.cssText = 'padding: 0; margin: 0;'

              initVPAID({ getAd: getVPAIDAd, videoSlot, adParameters }, specialBehavior); // slot: secureMode ? vpaidFrame.contentDocument.body : slot, originalSlot
            } else { emitter.emit(event.Player.PlayerLog, 'getVPAIDAd not found'); }
          }

          vpaidMediaUrl = vpaidMedia.url;
          vpaidFrame.contentWindow.document.write('<body><style>video { max-width: 100%; height: auto; }</style><script onload="window.onVPAIDLoad();" src="' + vpaidMedia.url + '"></scr' + 'ipt></body>');
        }

        // slot.appendChild(vpaidFrame);
        playerNode.appendChild(vpaidFrame)
      } else {
        emitter.emit(event.Player.PlayerLog, params.tid, 'parsing VAST ad');

        advID = AdvIDPrefix.VAST + getRandomString();

        let adParameters = {
          videos: [...mediaFiles.filter((mediaFile) => mediaFile.mimetype !== MediaType.JS)],
        };

        const specialBehavior = false;

        if (clickThruNode) {
          const clickThru = clickThruNode.textContent;
          adParameters = {
            ...adParameters,
            overlay: clickThru,
          };
        }

        try {
          unit = {
            advID,
            slot,
            trackers: currentAdTrackers,
            baseTrackers,
            params,
            paused: false,
            userInteracted: false,
            isViralize: false,
            isImpressionEmitted: false,
          };

          initVPAID({ getAd: getVPAIDAd, slot, videoSlot, adParameters: JSON.stringify(adParameters) }, specialBehavior);
        } catch (error) {
          emitter.emit(event.Ad.AdError, { advID, params, error: `vpaid error: ${error}` });
        }
      }
    } else {
      emitter.emit(event.Player.PlayerLog, params.tid, 'mediaFiles node doesnt exist or blacklisted. Cheching VASTAdTagURI');
      const VASTAdTagURINode = get(ad, 'VASTAdTagURI')[0]; // TODO: add support for other nodes

      if (VASTAdTagURINode) {
        emitter.emit(event.Player.PlayerLog, params.tid, 'parsing VASTAdTagURI');
        const redirectedVast = VASTAdTagURINode.textContent.trim();

        let inBlacklist = redirectedVast && config.bl && config.bl.some(url => redirectedVast.includes(url));
        if (!redirectedVast || inBlacklist) return;
        return await VPAIDModule({ vastUrl: redirectedVast, emitter, playerNode, vastParser, trackers: currentAdTrackers, baseTrackers, params, config, socket, logger, isChildVast: true, timeouts, uiManager, parentAdvInfo: advInfo, parentVastPrice: vastPrice, queueManager, impressionDetector });
      } else {
        emitter.emit(event.Player.TagCompleteRequest, { tid: params.tid, success: false });
        emitter.emit(event.Player.PlayerLog, params.tid, 'VASTAdTagURI node doesnt exist.');
      }
    }
  }

  const shouldURLBePrepared = !isChildVast;
  const vast = await vastParser(vastUrl, params.tid, shouldURLBePrepared);
  if (!vast) return;

  const ads = get(vast, 'Ad');

  if (ads.length > 0) {
    const adsToParse = params.aid === 0 ? ads : [ads[0]];
    adsToParse.forEach(async (ad) => parseAd(ad));
  } else {
    emitter.emit(event.Player.PlayerLog, params.tid, 'parsed ads array is empty');
    emitter.emit(event.Player.TagCompleteRequest, { tid: params.tid, success: false });

    const errorNode = get(vast, 'Error');
    if (errorNode.length) {
      const errorURL = errorNode[0].textContent.trim();
      API.call(errorURL, {}, {}, APICallMethod.IMAGE);
    }
  }
}

const createVPAIDModule = (cfg) => VPAIDModule(cfg);

export { VPAIDModule };
export default createVPAIDModule;
